/**
 * Compress an image DataURL to max 512px JPEG at 78% quality.
 * Keeps the image small enough for fast AI API calls while
 * retaining enough detail for Gemini to identify body panels.
 */
export const compressForAI = (dataUrl) =>
  new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const MAX = 512;
      const ratio = Math.min(MAX / img.width, MAX / img.height, 1);
      const canvas = document.createElement('canvas');
      canvas.width  = Math.round(img.width  * ratio);
      canvas.height = Math.round(img.height * ratio);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/jpeg', 0.78).split(',')[1]);
    };
    img.src = dataUrl;
  });
